import axios from "axios";
import { useNavigate } from "react-router-dom";
import DashNav from "../Dashboard/DashNav.js";
import * as React from "react";
import Stack from "@mui/material/Stack";
import Sidebar from "../Dashboard/Sidebar.js";
import Feed from "../Dashboard/Feed";
import { Box } from "@mui/system";
import {
    Button,
    Chip,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import {
    DataGrid, GridToolbar, GridToolbarQuickFilter,
    GridLogicOperator,
} from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { ToastContainer, toast } from "react-toastify";
import { DirectionsCar, Add, Delete, Feed as FeedIcon } from "@mui/icons-material";

const carBrandNames = require("./VehicleBrands.js");

// --- MODERN STYLED COMPONENTS ---

const RootContainer = styled(Box)({
  background: "#F8FAFC",
  minHeight: "100vh",
  display: "flex",
});

const ContentArea = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  marginLeft: "18vw",
  padding: "40px",
  width: "calc(100% - 18vw)",
  transition: "all 0.3s ease",
  [theme.breakpoints.down("md")]: {
    marginLeft: 0,
    width: "100%",
    padding: "20px",
    paddingTop: "84px",
  },
}));

const GlassCard = styled(Paper)({
  padding: "24px",
  borderRadius: "16px",
  background: "#FFFFFF",
  border: "1px solid #E2E8F0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
});

const StyledDataGrid = styled(DataGrid)({
  border: "none",
  backgroundColor: "#FFFFFF",
  borderRadius: "16px",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#F1F5F9",
    color: "#475569",
    fontWeight: 700,
    fontSize: "14px",
    borderBottom: "1px solid #E2E8F0",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #F1F5F9",
    color: "#1E293B",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #E2E8F0",
  },
  "& .wrap-text": {
    whiteSpace: "normal",
  },
});

const ModalBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500px",
  maxHeight: "90vh",
  overflowY: "auto",
  backgroundColor: "#FFFFFF",
  borderRadius: "20px",
  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
  outline: "none",
  [theme.breakpoints.down("sm")]: {
    width: "95%",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};




function CarFacts() {
    return (
        <RootContainer>
            <Sidebar />
            <CarFactsList />
        </RootContainer>
    );
}
const CarFactsList = () => {

    // Datagrid Columns
    const columns = [
        {
            field: "col0",
            headerName: "Actions",
            width: 120,
            sortable: false,
            filterable: false,
            renderCell: (cellValues) => {
                return (
                    <Stack direction="row" spacing={1}>
                        <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            startIcon={<Delete />}
                            onClick={() => {
                                handleDelete(cellValues.row.uuid)
                            }}
                            sx={{
                                borderRadius: "8px",
                                textTransform: "none",
                                "&:hover": { bgcolor: "#fef2f2" }
                            }}
                        >
                            Delete
                        </Button>
                    </Stack>
                );
            },
        },
        {
            field: "uuid",
            sortable: false,
            headerName: "UUID",
            width: 300,
        },
        {
            field: "title",
            sortable: false,
            headerName: "Title",
            width: 250,
        },
        {
            field: "desc",
            sortable: false,
            headerName: "Description",
            width: 400,
        }
    ];






    const [allCarFacts, setAllCarFacts] = React.useState([]);
    //isUpdating State is used for checking if the modal open is for updating or adding a new one hence changing the button name 
    const [isLoading, setisLoading] = React.useState(false)
    const [addNewFact, setAddNewFact] = React.useState({
        title: "",
        desc: "",
    });
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);









    function handleChange(evt) {
        const value = evt.target.value;
        setAddNewFact({
            ...addNewFact,
            [evt.target.name]: value,
        });
    }

    //------- ADD FACT FUNCTION STARTED -------

    const addNewFactFunc = async () => {
        const token = localStorage.getItem("accessToken");
        const config = {
            headers: {
                auth: token,
            },
        };

        function isInvalid(value) {
            return value === undefined || value.length === 0;
        }


        if (
            isInvalid(addNewFact.title) ||
            isInvalid(addNewFact.desc)

        ) {
            toast.error("All fields are mandatory!")
        } else {
            await axios
                .post("/carFacts", addNewFact, config)
                .then((response) => {
                    toast.success("Fact Added Successfully!");
                    getAllCarFacts()
                    setOpen(false)
                })
                .catch((err) => {
                    console.log(err);
                    if (err.response.data.error == "Fact Already Exists") {
                        toast.error("Fact Already Exists");
                    } else {
                        toast.error("Fact Cannot Be Added");
                    }
                });
        }
    };


    //------- DELETE FACT FUNCTION STARTED -------
    async function handleDelete(uuid) {

        if (window.confirm("You surely want to delete this fact?")) {
            await deleteTask(uuid)
        }      // await deleteUser(Value.row.uid) 
        else {
            await getAllCarFacts()
        }
    }

    const deleteTask = async (uuid) => {
        const token = localStorage.getItem("accessToken");
        const config = {
            headers: {
                auth: token,
            },
        };

        await axios
            .delete(`/deleteCarFact/${uuid}`, config)
            .then((response) => {

                toast.success("Fact Deleted Successfully!");
                getAllCarFacts()
                setOpen(false)
            })
            .catch((err) => {
                console.log(err);
                if (err.response.data.error == "Fact Already Exists") {
                    toast.error("Fact Already Exists");
                } else {
                    toast.error("Fact Cannot Be Deleted");
                }
            });

    };


    //------- GET ALL FACT FUNCTION STARTED -------

    const getAllCarFacts = async () => {
        setisLoading(true)
        const token = localStorage.getItem("accessToken");
        const config = {
            headers: {
                auth: token,
            },
        };
        axios
            .get("/carFacts", config)
            .then((response) => {
                setAllCarFacts(response.data.data);
                setisLoading(false)

            });
    };

    React.useEffect(() => {
        getAllCarFacts();
    }, []);




    return (
        <ContentArea>
            <Stack 
                direction={{ xs: "column", md: "row" }} 
                justifyContent="space-between" 
                alignItems={{ xs: "flex-start", md: "center" }} 
                spacing={3}
                sx={{ mb: 4 }}
            >
                <Box>
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 800,
                            color: "#1E293B",
                            fontFamily: "Kamerik",
                            letterSpacing: "-1.5px",
                            fontSize: { xs: "2rem", md: "3rem" }
                        }}
                    >
                        Manage Car Facts
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={() => { handleOpen(true) }}
                    sx={{
                        borderRadius: "12px",
                        px: 3,
                        bgcolor: "#1E293B",
                        fontWeight: 700,
                        height: "48px",
                        "&:hover": { bgcolor: "#0F172A" },
                        width: { xs: "100%", md: "auto" }
                    }}
                >
                    Add Fact
                </Button>
            </Stack>

            <GlassCard elevation={0}>
                <Box sx={{ height: "70vh", width: "100%" }}>
                    <StyledDataGrid
                        rows={allCarFacts || []}
                        columns={columns}
                        pageSize={100}
                        disableSelectionOnClick
                        loading={isLoading}
                        components={{
                            Toolbar: GridToolbar,
                        }}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 }
                            },
                        }}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        sx={{
                            "& .MuiDataGrid-toolbarContainer": {
                                padding: "16px",
                                gap: "12px",
                                borderBottom: "1px solid #E2E8F0",
                                "& .MuiButton-root": {
                                    color: "#64748B",
                                    fontWeight: 700,
                                    "&:hover": {
                                        color: "#1E293B",
                                    },
                                },
                            },
                        }}
                    />
                </Box>
            </GlassCard>



            <Modal
                open={open}
                onClose={handleClose}
            >
                <ModalBox>
                    <Box
                        sx={{
                            p: 3,
                            background: "linear-gradient(135deg, #1E293B 0%, #0F172A 100%)",
                            color: "#fff",
                            borderTopLeftRadius: "20px",
                            borderTopRightRadius: "20px",
                        }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 800, display: "flex", alignItems: "center", gap: 1 }}>
                            <FeedIcon /> Add New Fact
                        </Typography>
                    </Box>

                    <Box sx={{ p: 4 }}>
                        <Stack spacing={3}>
                            <TextField
                                label="Title"
                                variant="outlined"
                                fullWidth
                                name="title"
                                onChange={handleChange}
                                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
                            />

                            <TextField
                                label="Description"
                                multiline
                                rows={4}
                                variant="outlined"
                                fullWidth
                                name="desc"
                                onChange={handleChange}
                                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
                            />

                            <Button
                                variant="contained"
                                fullWidth
                                size="large"
                                onClick={addNewFactFunc}
                                sx={{
                                    mt: 2,
                                    height: "56px",
                                    borderRadius: "12px",
                                    bgcolor: "#3B82F6",
                                    fontSize: "1rem",
                                    fontWeight: 700,
                                    "&:hover": { bgcolor: "#2563EB" },
                                }}
                            >
                                Add Fact
                            </Button>
                        </Stack>
                    </Box>
                </ModalBox>
            </Modal>




            <ToastContainer />
            <ToastContainer position="bottom-right" />
        </ContentArea>
    );
};
export default CarFacts;
